<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Users
                <!-- <q-icon name="mdi-help-circle" size="sm">
                  <q-tooltip>
                    <div style="max-width: 250px; font-size: 14px">
                      This is the area where you will be able to create Team
                      Manager and Coach accounts/Users for your association.
                      This is currently under development and will be out soon!
                    </div>
                  </q-tooltip>
                </q-icon> -->
              </div>
              <q-btn
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 270px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td :props="data.props">
                        <q-btn
                          :loading="removingUserID == data.props.row.id"
                          @click="removeUser(data.props.row.id)"
                          round
                          flat
                          color="negative"
                        >
                          <q-icon name="mdi-trash-can-outline"></q-icon>
                          <q-tooltip>Remove User</q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" persistent max-width="90vw">
      <q-card v-if="newDialog" tile style="width: 600px; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">New User</div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="formHeight q-pa-none">
          <q-scroll-area style="height: calc(100vh - 191px) !important">
            <userForm
              ref="newForm"
              forAssociation
              @close="newDialog = false"
              @loadingStateChanged="state => (createLoading = state)"
            />
          </q-scroll-area>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" persistent max-width="90vw">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 600px; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">User</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="close"> </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="formHeight q-pa-none">
          <q-scroll-area style="height: 400px !important">
            <userForm
              ref="editForm"
              :id="viewFormData.id"
              forAssociation
              @close="close"
              @loadingStateChanged="state => (saveLoading = state)"
            />
          </q-scroll-area>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import userForm from "@/components/users/userForm.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    userForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      gridData: "associations/users",
      dataLoading: "associations/usersLoading"
    })
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "id",
        label: "ID",
        align: "left",
        field: "id",
        sortable: true
      },
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true
      },
      {
        name: "email",
        label: "Email",
        align: "left",
        field: "email",
        sortable: true
      },
      {
        name: "role",
        label: "Role",
        align: "left",
        field: "role",

        sortable: true
      },
      {
        name: "created_at",
        label: "Created At",
        align: "left",
        field: "created_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true
      },
      {
        name: "updated_at",
        label: "Updated At",
        align: "left",
        field: "updated_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true
      },
      {
        name: "actions",
        label: "Actions",
        align: "left",
        sortable: false
      }
    ],
    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    removingUserID: null
  }),
  watch: {
    $route: function() {
      this.handleRoute();
    }
  },
  mounted() {
    this.loadData();
    this.handleRoute();
  },
  methods: {
    handleDoubleClick(row) {
      if (this.currentUserData.role != "Sport Manager") {
        this.$router.push(`${this.$route.path}/${row.id}`);
      }
    },
    loadData() {
      this.$store.dispatch(
        "associations/loadUsers",
        this.currentUserData.currentAssociation_id
      );
      this.$store.dispatch("associations/loadMembersForAssociation", {
        id: this.currentUserData.currentAssociation_id
      });
    },
    handleRoute() {
      if (this.$route.params.user_id) {
        this.viewFormData = { id: this.$route.params.user_id };
        this.$nextTick(() => {
          this.viewDetailsDialog = true;
        });
      } else {
        this.viewDetailsDialog = false;
      }
    },
    close() {
      this.$router.push("/entries/supportTeam");
    },
    removeUser(id) {
      this.removingUserID = id;
      this.$store
        .dispatch("users/userRemovePermission", {
          users_id: id
        })
        .then(result => {
          if (result.Result == "Success") {
            this.$store.dispatch(
              "associations/loadUsers",
              this.currentUserData.currentAssociation_id
            );
            this.removingUserID = null;
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: 400px;
  max-height: 400px;
}
</style>
